/*
 * ANIME CRUSH — CTA BEHAVIOUR
 *
 * WHY THIS EXISTS RATHER THAN CSS
 * "Shop the Collection" pointed at #ac-grid, and #ac-grid did not exist, so
 * the most prominent button in the design did nothing at all. Giving it a real
 * target fixed the dead link but the landing was wrong: the first row of
 * products arrived half-hidden behind the sticky collection toolbar.
 *
 * `scroll-margin-top` on the anchor did not help, because the theme handles
 * in-page anchor clicks itself and scrolls without honouring it. Rather than
 * fight that with a bigger number that might be wrong on the next layout, the
 * scroll is taken over here and the offset is MEASURED from whatever is
 * actually sticky on the page at that moment.
 *
 * A button that scrolls the thing it promised under a header is only slightly
 * better than a button that does nothing.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sum the height of everything that will still be pinned to the top of the
   * viewport after the scroll finishes. Measured, so a layout change cannot
   * silently reintroduce the clipping. */
  /*
   * The chrome that WILL be pinned once the scroll finishes.
   *
   * Two earlier attempts both failed for the same reason: they read
   * getComputedStyle().position at CLICK time, when the page is still at the
   * top and the collection toolbar is a thousand pixels further down and not
   * pinned at all. So it was skipped, the offset came out at 24, and the
   * first row of products landed under the toolbar anyway.
   *
   * Heights do not depend on scroll position. The header is 88 and the
   * toolbar 61 whether or not either is currently stuck, so the heights are
   * what gets measured.
   */
  function stickyOffset() {
    var total = 0;
    ['.Header', '.CollectionToolbar'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var h = el.getBoundingClientRect().height;
      if (h > 0 && h < 220) total += h;
    });
    return total + 24;   /* a little air, so it does not read as flush */
  }

  function scrollToTarget(target) {
    var y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;

    var href = a.getAttribute('href');
    if (!href || href === '#' || href.length < 2) return;

    var target;
    try { target = document.querySelector(href); } catch (err) { return; }

    /* No target means this is not ours to handle; let the page do whatever it
     * was going to do rather than silently swallowing the click. */
    if (!target) return;

    e.preventDefault();
    scrollToTarget(target);

    /* Keep the URL honest and the back button useful, without letting the
     * browser perform its own unoffset jump. */
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', href);
    }
  });

  /* A page loaded with #ac-grid already in the URL should land correctly too. */
  window.addEventListener('load', function () {
    if (!window.location.hash || window.location.hash.length < 2) return;
    var target;
    try { target = document.querySelector(window.location.hash); } catch (err) { return; }
    if (!target) return;
    window.setTimeout(function () { scrollToTarget(target); }, 120);
  });
})();

/*
 * A REVIEW PHOTO THAT NO LONGER EXISTS IS HIDDEN, NOT SHOWN BROKEN.
 *
 * The Trustoo reviews widget renders photos from img.trustoo.io, and four of
 * them (uploaded 2024-11-21) answer 404 on Trustoo's own CDN - measured
 * 2026-10-08 - so every product page and the home page showed broken-image
 * icons inside the reviews. The data is the app's; this only stops a missing
 * file from being painted. `error` does not bubble, so it is caught in the
 * capture phase, which also covers photos the widget injects later. A tile
 * that held nothing but the photo goes with it.
 */
(function () {
  'use strict';
  function isReviewImage(img) {
    return img && img.tagName === 'IMG' && /(^|\.)trustoo\.io$/.test((function () {
      try { return new URL(img.currentSrc || img.src, location.href).hostname; } catch (e) { return ''; }
    })());
  }
  function hide(img) {
    var tile = img.parentElement;
    img.style.display = 'none';
    if (tile && tile !== document.body && tile.children.length === 1 && !tile.textContent.trim()) tile.style.display = 'none';
  }
  document.addEventListener('error', function (e) {
    if (isReviewImage(e.target)) hide(e.target);
  }, true);
  function sweep() {
    Array.prototype.forEach.call(document.images, function (img) {
      if (img.complete && img.naturalWidth === 0 && isReviewImage(img)) hide(img);
    });
  }
  if (document.readyState === 'complete') sweep(); else window.addEventListener('load', sweep);
})();
